
export class source{
    name: string
    url: string
    type: string
    file:FileSourceParams
    database:DatabaseParams 
    website:WebsiteParams
  }
  export class WebsiteParams{
      url:string
  }
  export class FileSourceParams{
      path:string
      delimiter:string
      headerDisplay:boolean
      autoDetectColumnNames:boolean
      startPosition:string
  }
  export class DatabaseParams{
      driverLibrary:string
      driverClass:string
      connectionString:string
      username:string
      password:string
      statement:string
      useColumnValue:boolean
      trackingColumn:string
  }

  